// Function to set a value in localStorage with expiration (hours)
function setLocalStorage(name, value, hoursToExpire) {
  const now = new Date().getTime();
  const expireTime = now + hoursToExpire * 60 * 60 * 1000;

  const data = {
    value: value,
    expiresAt: expireTime
  };

  localStorage.setItem(name, JSON.stringify(data));
}

// Function to get a value from localStorage
function getLocalStorage(name) {
  const stored = localStorage.getItem(name);
  if (!stored) return null;

  const data = JSON.parse(stored);
  const now = new Date().getTime();

  if (now > data.expiresAt) {
    localStorage.removeItem(name); // remove expired
    return null;
  }

  return data.value;
}

// Function to check if localStorage key exists and is not expired
function checkLocalStorage(name) {
  return getLocalStorage(name) !== null;
}